import { render, staticRenderFns } from "./user-not-approved.vue?vue&type=template&id=a8eef066&scoped=true&"
import script from "./user-not-approved.vue?vue&type=script&lang=js&"
export * from "./user-not-approved.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8eef066",
  null
  
)

export default component.exports